import "@hotwired/turbo-rails"
require("../stimulus");
require("../pwa");

import TurboPower from 'turbo_power'
TurboPower.initialize(Turbo.StreamActions)
